import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import {
  Button,
  ButtonIcon,
  FormHeader,
  InputBox,
  Link,
  SectionHeader,
  TopMenu,
} from "../../components";
import "react-notifications-component/dist/theme.css";
import { CheckValidity } from "../../utils/formValidity";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { adsAuthentication } from "./service/auth.service";
import { login, setAdsSession } from "../../utils/auth";
import { Store } from "react-notifications-component";
import { setAdsUserDetails } from "../AdsPlatform/redux/actions";

const AdsSignIn = (props) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: {
      key: "email",
      label: "Email",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "example@email.com",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    password: {
      key: "password",
      label: "Password",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "password",
        placeholder: "**********",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const handleChange = async (event, inputIdentity) => {
    const updateNewProductForm = {
      ...formData,
    };

    updateNewProductForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateNewProductForm[inputIdentity].value,
      updateNewProductForm[inputIdentity].validation
    );

    if (validityRes) {
      updateNewProductForm[inputIdentity].isValid = validityRes.isValid;
      updateNewProductForm[inputIdentity].invalidReason = validityRes.reason;
      updateNewProductForm[inputIdentity].value = event;
      updateNewProductForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateNewProductForm) {
        formIsValid =
          updateNewProductForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateNewProductForm);
    }
  };

  //update input validation
  const updateInputValidationErrors = async () => {
    let df = { ...formData };
    let formIsValid = true;
    for (let itemKey of Object.keys(df)) {
      if (itemKey === "firstName" || itemKey === "firstName") {
        if (df[itemKey].value === "" || df[itemKey].invalidReason) {
          df[itemKey].touched = true;
          formIsValid = false;
        }
      }
    }
    await setFormData(df);
    return formIsValid;
  };

  const onClickSave = async (e) => {
    setIsLoading(true);
    const updateNewProductForm = {
      ...formData,
    };
    try {
      let result = await adsAuthentication({
        username: updateNewProductForm.email.value,
        password: updateNewProductForm.password.value,
      });
      console.log("result", result);
      if (result.data?.status) {
        setAdsSession(result.data?.data?.token);
        dispatch(setAdsUserDetails(result.data.data?.company));
        Store.addNotification({
          title: "Wonderful!",
          message: "Successfully Login!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        setIsLoading(false);
        props.history.push("/ads/campaign");
      } else {
        Store.addNotification({
          title: "Error!",
          message: "Login Failed!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      Store.addNotification({
        title: "Error",
        message: error.message,
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });
    }
  };

  const updateNewProductForm = { ...formData };

  return (
    <>
      <div className={"ads-sign-in-wrapper"}>
        <div>
          <TopMenu
            data={{
              size: "sm",
              isLanguage: false,
              isLogo: false,
              isProfile: false,
            }}
          />
        </div>
        <div className={"asiw__main-wrp"}>
          <div className={"asiw__nagivator"}>
            <ButtonIcon
              data={{
                iconName: "h-wrrow-left",
                size: "md",
                type: "light",
              }}
              onClick={() => {
                props.history.push("/ads");
              }}
            />
            Back to home
          </div>
          <div className={"asiw__form"}>
            <div className={"asiwf__header-wrapper"}>
              <div className={"asiwf__hw-logo"}>
                <img
                  src={require("../../assets/img/logo_new.png")}
                  alt={"logo"}
                />
              </div>
              <FormHeader
                data={{
                  formHeader: "Welcome back!",
                  size: "md-md",
                }}
              />
              <SectionHeader
                data={{
                  title: "Sign in to access your account.",
                  size: "md-sm",
                }}
              />
            </div>
            <InputBox
              data={updateNewProductForm.email}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(
                  e.target.value,
                  updateNewProductForm.email.key
                );
              }}
            />
            <InputBox
              data={updateNewProductForm.password}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(
                  e.target.value,
                  updateNewProductForm.password.key
                );
              }}
            />
            <div className={"asiwf__forgot"}>Forgot password ?</div>
            <Button
              data={{
                btnName: "SIGN IN",
                buttonType:
                  updateNewProductForm.email.value === "" ||
                  updateNewProductForm.password.value === ""
                    ? "primary disabled"
                    : "primary",
                buttonSize: "lg",
                isLoading: isLoading,
              }}
              onClick={async (e) => {
                e.preventDefault();
                await onClickSave(e);
              }}
            />
            <div
              className={
                "d-flex flex-column justify-content-center align-items-center mt-3"
              }
            >
              <Link
                data={{
                  title: "Don’t have an account?",
                  link: "Sign Up",
                }}
                onClick={() => {
                  props.history.push("/ads/sign-up");
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(AdsSignIn);
